import styled from "styled-components";

export const SignInStyle = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 100px;

  .login-area {
    height: 300px;
    background: white;
    border-radius: 10px;
    width: 400px;
    margin: 10px;
    padding: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    p {
      color: #9aa7a2;
      font-weight: 700;
      font-size: 20px;
    }

    button {
      background: #00805c59;
      width: 120px;
      height: 50px;
      border: none;
      border-radius: 10px;
      color: #ffffff;
      font-weight: 700;
      transition: opacity 2s;
    }

    button:hover {
      background: #eea70980;
    }
  }
`;
